import { render, staticRenderFns } from "./PlayerListAccountBadge.vue?vue&type=template&id=177f1e7d"
import script from "./PlayerListAccountBadge.vue?vue&type=script&lang=js"
export * from "./PlayerListAccountBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports